import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import * as React from 'react';
import cn from 'classnames';
import { LoadingIcon } from '@rescui/icons';
import styles from '../input.p.module.css.js';
import { CustomIcon } from './custom-icon.js'; // eslint-disable-next-line complexity

var RightIcons = function RightIcons(_ref) {
  var icon = _ref.icon,
      busy = _ref.busy,
      size = _ref.size,
      onClear = _ref.onClear,
      clearIcon = _ref.clearIcon,
      iconIsAction = _ref.iconIsAction,
      iconIsFocusable = _ref.iconIsFocusable,
      empty = _ref.empty;
  var icons = [];

  if (onClear && !empty) {
    icons.push(
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("span", {
      role: "button",
      key: "clear",
      className: cn(styles.icon, styles.right, styles.action),
      onClick: onClear,
      "data-test": "input__clear-icon",
      tabIndex: -1
    }, /*#__PURE__*/React.cloneElement(clearIcon, {
      size: size,
      focusable: false,
      className: clearIcon.props.className
    })));
  }

  if (icon) {
    icons.push( /*#__PURE__*/React.createElement(CustomIcon, {
      key: "custom-icon",
      size: size,
      iconPosition: 'right',
      iconIsFocusable: iconIsFocusable,
      iconIsAction: iconIsAction,
      icon: icon
    }));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, _sliceInstanceProperty(icons).call(icons, 0, busy ? -1 : icons.length), busy && /*#__PURE__*/React.createElement("span", {
    key: "loading",
    className: cn(styles.icon, styles.right)
  }, /*#__PURE__*/React.createElement(LoadingIcon, {
    size: size,
    "data-test": "input__busy-icon"
  })));
};

export { RightIcons };
